import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PropTypes from "prop-types";
import React, { useState } from "react";
import MessageInputDialog from "@components/MessageInputDialog";
import TableMenu from "@components/TableMenu";

/* Binary messages disabled.
import { contentTypeLabels } from "@utils/message"; */

const useStyles = makeStyles(() => ({
  rowButton: {
    marginTop: "-14px",
    marginBottom: "-14px",
  },
  control: {
    paddingTop: "15px",
    paddingBottom: "10px",
    textAlign: "right",
  },
  contentTypeCell: { width: "150px" },
  messagesHeadCell: {
    fontSize: "1rem",
    fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: "0.00938em",
  },
  menuCell: {
    width: "48px",
    paddingBottom: "2px",
    paddingTop: "2px",
  },
}));

function MessagesSelector(props) {
  const classes = useStyles();

  const [openMessageInputDialog, setOpenMessageInputDialog] = useState(false);
  const [messageInputDialogData, setMessageInputDialogData] = useState(null);

  function showMessageDialog(data = null) {
    setMessageInputDialogData(data);
    setOpenMessageInputDialog(true);
  }

  function hideMessageDialog() {
    setOpenMessageInputDialog(false);
    setMessageInputDialogData(null);
  }

  function renderRow(message) {
    function handleDelete(row) {
      props.onChange(
        props.messages.filter((messageItem) => messageItem.id !== row.id)
      );
    }

    function handleEdit(row) {
      handleEditMessage(row);
    }

    return (
      <TableRow key={message.id}>
        {/* Binary messages disabled.
        <TableCell>{contentTypeLabels[message.contentType]}</TableCell> */}
        <TableCell>{message.message}</TableCell>
        <TableCell className={classes.menuCell} align="right">
          <TableMenu
            options={[
              {
                label: "Editar",
                icon: EditIcon,
                onClick: handleEdit,
              },
              {
                label: "Excluir",
                icon: DeleteIcon,
                onClick: handleDelete,
              },
            ]}
            data={message}
          />
        </TableCell>
      </TableRow>
    );
  }

  function renderNoMessagesRow() {
    return (
      <TableRow>
        <TableCell colSpan={3} align="center">
          Nenhuma mensagem
        </TableCell>
      </TableRow>
    );
  }

  function handleAddMessage() {
    showMessageDialog();
  }

  function handleEditMessage(data) {
    showMessageDialog(data);
  }

  function handleCancelMessageDialog() {
    hideMessageDialog();
  }

  function handleApplyMessageDialog(data) {
    if (messageInputDialogData) {
      props.onChange(
        props.messages.map((message) => {
          if (message.id === messageInputDialogData.id) {
            return data;
          }
          return message;
        })
      );
    } else {
      props.onChange([...props.messages, data]);
    }

    hideMessageDialog();
  }

  return (
    <div>
      <Table>
        <TableHead>
          <TableRow>
            {/* Binary messages disabled.
            <TableCell className={classes.contentTypeCell}>
              Tipo de Conteúdo
            </TableCell>
            <TableCell>Mensagem</TableCell>
            */}
            <TableCell className={classes.messagesHeadCell}>
              Mensagens
            </TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.messages &&
            props.messages.map((message, i) => renderRow(message, i))}
          {props.messages.length === 0 && renderNoMessagesRow()}
        </TableBody>
      </Table>

      <div className={classes.control}>
        <Button color="primary" variant="contained" onClick={handleAddMessage}>
          Adicionar
        </Button>
      </div>

      <MessageInputDialog
        open={openMessageInputDialog}
        data={messageInputDialogData}
        onCancel={handleCancelMessageDialog}
        onClose={handleCancelMessageDialog}
        onApply={handleApplyMessageDialog}
      />
    </div>
  );
}

MessagesSelector.defaultProps = {
  messages: [],
  required: false,
  onChange: () => {},
};

MessagesSelector.propTypes = {
  messages: PropTypes.array,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MessagesSelector;
